import React from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";
import BannerImages from "../../Common/BannerImages";
import { useTranslation } from "react-i18next";
import { templateActions } from "../../templateStore";
import Preview from "../../Application/ShopSelection/Preview";
import { useSelector } from "react-redux";
function ApplicationShopSelection({ selectedRows }: any) {
    const { t } = useTranslation();
    const [isReady, setIsReady] = React.useState(false);

    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);
    let schema: any = useSelector(
        (state: any) => state.global.entityDetails.franchise_schema
    );
    const boutique = schema + "_" + selectedRows[0].shopId;

    const bannierImagePath = React.useMemo(
        () => ["Application", "ChoixBoutique", boutique, "BannierBoutique"],
        [boutique]
    );

    const logoImagePath = React.useMemo(
        () => ["Application", "ChoixBoutique", boutique, "LogoBoutique"],
        [boutique]
    );
    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }
    const tabs = [
        {
            title: t("Shop selection"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <div className="banner-images">
                            <BannerImages
                                dataPath={bannierImagePath}
                                title="Image de la banniere"
                                size="(png,jpg,jpeg ou webp)"
                            />
                            <BannerImages
                                dataPath={logoImagePath}
                                title="Logo"
                                size="30*30 (png,jpg,jpeg ou webp)"
                            />
                        </div>
                    </section>
                </div>
            ),
            customClassName: "",
        },
    ];

    React.useEffect(() => {
        const ensureAllPaths = async () => {
            await templateActions.ensurePathExists(
                ["Application", "ChoixBoutique", boutique, "BannierBoutique"],
                { Url: "", Name: "", Type: "", Extenxion: "" }
            );

            await templateActions.ensurePathExists(
                ["Application", "ChoixBoutique", boutique, "LogoBoutique"],
                { Url: "", Name: "", Type: "", Extenxion: "" }
            );

            setIsReady(true);
        };

        ensureAllPaths();
    }, [boutique]);

    if (!isReady) return null;

    return (
        <div className="d-flex justify-content-between">
            <div style={{ width: "65% " }}>
                <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                    <Nav
                        tabs
                        style={{
                            backgroundColor: "white",
                            width: "50px",
                            display: "grid",
                            gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                            border: "unset",
                        }}
                    >
                        {tabs.map((element, index) => {
                            return (
                                <NavItem
                                    key={index}
                                    className={classNames(
                                        "pb-1",
                                        "d-flex align-items-center text-nowrap",
                                        {
                                            "disable-nav-item__clz":
                                                activeTab !== index,
                                        },
                                        element.customClassName
                                    )}
                                    style={{
                                        cursor: "pointer",
                                        borderBottom:
                                            activeTab === index
                                                ? `${mainColor} 3px solid`
                                                : "",
                                    }}
                                >
                                    <NavLink
                                        className={classNames(
                                            "text-dark w-100",
                                            {
                                                "active customer-account-menu-nav-link-active__clz":
                                                    activeTab === index,
                                                "customer-account-menu-nav-link-disable__clz":
                                                    activeTab !== index,
                                            }
                                        )}
                                        onClick={() => toggleNav(index)}
                                    >
                                        <span
                                            className="px-2"
                                            style={{
                                                font:
                                                    "normal normal 600 20px/27px Segoe UI",
                                            }}
                                        >
                                            {element.title}
                                        </span>
                                    </NavLink>
                                </NavItem>
                            );
                        })}
                    </Nav>
                </div>
                <TabContent activeTab={activeTab} className="h-100">
                    {tabs.map((element, index) => {
                        return (
                            <TabPane
                                tabId={index}
                                key={index}
                                style={{ height: "90%" }}
                            >
                                {element.content}
                            </TabPane>
                        );
                    })}
                </TabContent>
            </div>
            <div style={{ width: "35%" }}>
                <Preview
                    shopData={{
                        shopName: selectedRows[0].Boutique,
                        shopAdress: selectedRows[0].Adresse,
                        boutique: boutique,
                    }}
                />
            </div>
        </div>
    );
}

export default ApplicationShopSelection;
